import React, { useState, useContext } from 'react';
import { isWidgetEnabled, WidgetContext } from '../../widgets/WidgetContext';
import { getMatchIdOrStageId } from '../../utils/getMatchIdOrStageId';

export default function LiveTrackerToggle(props) {
    const widgetContext = useContext(WidgetContext);
    const event = props.event;
    const widgetEnabled = isWidgetEnabled(event.sportRef, event.widgetType, event.geniusId, event.lsportWidgetId);
    const [widgetIsOpen, setWidgetIsOpen] = useState(false)

    function toggleLiveTracker(e) {
        e.preventDefault();
        e.stopPropagation();
        const containerId = `#br_widget_checkbet_${event.ticketRef}_${event.id}`;
        if (widgetContext.widgetContainerId !== containerId) {
            if (widgetEnabled) {
                widgetContext.setWidget({
                    widgetGeniusId: event.geniusId,
                    widgetLsportId: event.lsportWidgetId,
                    widgetProviderType: event.widgetType,
                    widgetSportId: event.sportRef,
                    widgetStartCollapsed: true,
                    widgetS5Layout: '#2',
                    widgetMatchId: getMatchIdOrStageId(event),
                    widgetContainerId: containerId
                });

            }
        } else if (event.id !== widgetContext.widgetMatchId) {
            widgetContext.setWidget({
                widgetMatchId: getMatchIdOrStageId(event)
            });
        } else {
            widgetContext.setWidget({
                widgetMatchId: null,
                widgetContainerId: null
            });
        }
        setWidgetIsOpen(!widgetIsOpen)
    }

    return (
        <>
            {(event.id != null && isWidgetEnabled(event.sportRef, event.widgetType, event.geniusId, event.lsportWidgetId))
                &&
                <div className='live-tracker__wrapper' onClick={toggleLiveTracker}>
                    <div>
                        <span className='live-tracker__text-stats'>Statistiche / Live</span>
                    </div>
                    <div className={`live-tracker__icon-arrow-${widgetIsOpen ? 'up' : 'down'}`}></div>
                </div>
            }
            <hr className="mb_4 mt-4" />
        </>
    );
}
